import { render } from "./GlutenFreeDetails.vue?vue&type=template&id=695934d5"
import script from "./GlutenFreeDetails.vue?vue&type=script&lang=js"
export * from "./GlutenFreeDetails.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__